import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
//import { MasterLayoutComponent } from '../mnt-master/master-layout/master-layout.component'
import { InvoicesListComponent } from './invoices-list/invoices-list.component';
import { ProductListComponent } from './product-list/product-list.component';
import { ProductQuantityComponent } from './product-quantity/product-quantity.component';
import { PrintSpecsComponent } from './print-specs/print-specs.component';
import { InkTypeComponent } from './ink-type/ink-type.component';
import { FinishingComponent } from './finishing/finishing.component';
import { TermInvoiceComponent } from './term-invoice/term-invoice.component';
import { PrintInvoiceComponent } from './print-invoice/print-invoice.component';

const routes: Routes = [
  {
    path: '', component: InvoicesListComponent
  },
  {
    path: "product-list",component: ProductListComponent
  },
  {
    path: "product-quantity",component: ProductQuantityComponent
  },
  {
    path: "print-specs",component: PrintSpecsComponent
  },
  {
    path: "ink-type",component: InkTypeComponent
  },
  {
    path: "finishing",component: FinishingComponent
  },
  {
    path: "term-invoice",component: TermInvoiceComponent
  },
  {
    path: "print-invoice/:invoiceID",component: PrintInvoiceComponent
  },
  {
    path: ":invoiceID",component: InvoicesListComponent
  }


];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MntInvoicesRoutingModule { }



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/mnt-invoices-routing.module.ts